module.exports = __webpack_public_path__ + "img/result-l.139ce78f.png";